import React from "react";
import PropTypes from "prop-types";
import { StatusIcon } from "./statusBadgeStyles.js";
import { retrieveStatusIconImg } from "../../../utilities/index.js";

const StatusBadge = ({ status }) => {
  const imgSrc = retrieveStatusIconImg(status);

  return <StatusIcon src={imgSrc} />;
};

StatusBadge.propTypes = {
  status: PropTypes.number,
};
StatusBadge.defaultProps = {
  status: 1,
};

export default StatusBadge;
